import Hero from '../../components/Hero'
import { Link } from 'react-router-dom'
import './ConsumableServices.css'

const ConsumableServices = () => {
  return (
    <>
      <Hero 
        title="Consumable Services"
        subtitle="Reliable supply of essential consumables such as hand towels, toilet paper, soaps, and bin liners, ensuring your facilities remain stocked, hygienic, and sustainable."
        backgroundImage="/services/consumables/consumables.png"
        height="55.78125vh"
      />
      
      <section>
        <div className="section-header">
          <h2>Consumable Services</h2>
        </div>
        <p>We provide comprehensive consumable supply solutions to keep your facilities well-stocked and operational. Our range includes essential supplies for cleaning, hygiene, and maintenance, ensuring your business runs smoothly without interruption.</p>
        <div className="grounds-grid">
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Cleaning Supplies</h3>
              <p>Complete range of cleaning chemicals, detergents, and equipment to maintain high standards of cleanliness and hygiene across your facility.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Paper Products</h3>
              <p>Essential paper supplies including toilet paper, paper towels, and tissues to ensure comfort and hygiene for staff and visitors.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Waste Management Supplies</h3>
              <p>Comprehensive range of bins, liners, and waste management equipment to maintain clean, organised, and compliant facilities.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Maintenance Consumables</h3>
              <p>Essential maintenance supplies including filters, lubricants, and replacement parts to keep your equipment running efficiently.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Tea Towel Services</h3>
              <p>Professional tea towel supply and laundering services to maintain hygiene standards in kitchens and food preparation areas.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Uniform Laundry Services</h3>
              <p>Complete uniform cleaning and maintenance services to ensure your staff always look professional and presentable.</p>
            </article>
          </Link>
        </div>
      </section>
      
      <section className="cta-section">
        <h2>Keep Your Facility Fully Stocked</h2>
        <p>Our consumable services ensure your facility never runs out of essential supplies. Contact us to learn how we can streamline your supply management and keep your operations running smoothly.</p>
        <a className="cta-button" href="/contact">Enquire Now</a>
      </section>
    </>
  )
}

export default ConsumableServices
